import {
    GivelifyButton,
    GivelifyIcon,
    GivelifyLabel,
    GivelifyLink,
} from '@givelify/ui';
import { styled } from '@mui/material';
import { ReactComponent as LogoSvg } from '../../../../assets/givelify-rebranding-logo.svg';

export const Container = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    overflowX: 'hidden',
    backgroundColor: '#F9FAFC',
    [theme.breakpoints.down('xs')]: {
        textAlign: 'center',
    },
    [theme.breakpoints.down('sm')]: {
        alignContent: 'flex-start',
    },
    '@media (max-width:320px)': {
        height: 'auto',
        overflowY: 'scroll',
    },
}));

export const Content = styled('div')(({ theme }) => ({
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    margin: '0 auto',
    padding: theme.spacing(1),
    paddingTop: 48,
    paddingBottom: 17,
    backgroundColor: '#F9FAFC',
    [theme.breakpoints.down('sm')]: {
        width: 343,
        maxWidth: 343,
        paddingTop: 32,
    },
    '@media (max-width:320px)': {
        width: 288,
        maxWidth: 288,
    },
}));

export const Body = styled('div')(() => ({
    minHeight: 630,
    backgroundColor: 'white',
    boxShadow:
        '0px 0px 4px rgba(10, 0, 77, 0.039), 0px 5px 20px rgba(10, 0, 77, 0.039)',
    borderRadius: 60,
    '@media (max-width:960px)': {
        borderRadius: 40,
    },
    '@media (max-width:320px)': {
        width: 288,
        borderRadius: 20,
    },
}));

export const LoginBody = styled('div')(({ theme }) => ({
    padding: '52px 76px 31px',
    [theme.breakpoints.down('sm')]: {
        padding: '24px 16px 8px 16px',
    },
    '& hr': {
        color: '#EEEDF3',
    },
}));

export const LogoContent = styled('div')(() => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
}));

export const Logo = styled(LogoSvg)(({ theme }) => ({
    height: 54,
    [theme.breakpoints.down('sm')]: {
        height: 34,
    },
}));

export const Form = styled('div')(() => ({
    width: '100%',
    height: '100%',
    paddingTop: 84,
    '@media (max-width:320px)': {
        paddingTop: 40,
    },
}));

export const DonateBody = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 106,
    padding: '15px 80px 41px',
    [theme.breakpoints.down('sm')]: {
        height: 84,
        padding: '16px 24px',
    },
    '@media (max-width:320px)': {
        height: 118,
        flexDirection: 'column',
        alignItems: 'center',
        padding: '24px 48px',
    },
}));

export const GiveButton = styled(GivelifyButton)(({ theme }) => ({
    width: 160,
    height: 42,
    minWidth: 160,
    [theme.breakpoints.down('sm')]: {
        width: 147,
        height: 36,
        minWidth: 147,
    },
}));

export const SecuredRow = styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    marginTop: '24px',
    justifyContent: 'center',
    justifyItems: 'center',
    columnGap: 4,
    [theme.breakpoints.down('sm')]: {
        '& > :first-child': {
            marginRight: 4,
        },
    },
    [theme.breakpoints.down('sm')]: {
        margin: '12px 0px',
        gridTemplateColumns: 'auto',
    },
}));

export const Footer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#F9FAFC',
    [theme.breakpoints.down('sm')]: {
        padding: '16px 40px',
    },
    '@media (max-width:320px)': {
        padding: '16px 0px',
    },
}));

export const SupportRowMobile = styled('div')(({ theme }) => ({
    display: 'none',
    [theme.breakpoints.down('sm')]: {
        display: 'flex',
    },
}));

export const LinkWithoutUnderline = styled(GivelifyLink)(() => ({
    textDecoration: 'none',
    cursor: 'pointer',
    '&:focus, &:hover, &:visited, &:link, &:active': {
        textDecoration: 'none',
    },
}));

export const BottomLabel = styled(GivelifyLabel)(({ theme }) => ({
    cursor: 'pointer',
}));

export const CopyRow = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    columnGap: 8,
    marginBottom: 24,
    [theme.breakpoints.down('tablet')]: {
        display: 'grid',
        gridTemplateColumns: 'auto auto auto',
        justifyItems: 'center',
        '&>:first-child': {
            gridRow: 2,
            gridColumn: 'span 3',
        },
    },
    [theme.breakpoints.down('sm')]: {
        marginTop: 16,
        marginBottom: 0,
        marginRight: 0,
    },
}));

export const LockIcon = styled(GivelifyIcon)(() => ({
    verticalAlign: 'middle',
    marginRight: 4,
}));
